import { round } from "../../../utils/utils"
import { EmptyCell } from "./EmptyCell"

export const PercentLabel = ({ value, decimalPlaces = 3 }) => {
  if (!value && value != 0) return <EmptyCell />
  return <div>{round(value * 100, decimalPlaces).toLocaleString("pt-br", { minimumFractionDigits: decimalPlaces })}%</div>
}
